<qaroni-counter-widget
  icon="report_problem"
  linkText="Ir al listado"
  i18n-linkText
  [count]="$counter()"
  [label]="$counter() | i18nPlural: pluralMapping"
  [color]="hasRequests ? 'danger' : 'accent'"
  [alert]="hasRequests"
  (action)="goToCheckRequests()" />
